import { format, parseISO } from 'date-fns'

import { env } from '@/constants/configs'

import type { IRedeemErrorVariant, IRedeemQueryPrefill } from '../types/schema'

interface Args {
  giftNumber?: string
  prefill?: IRedeemQueryPrefill | null
  branchName?: string
  /** Which failure sent the user here. Omitted only by callers that predate the split. */
  variant?: IRedeemErrorVariant
}

/**
 * The message the LINE CTA opens with. `USED Gift Request` is verbatim — the reservation team
 * filters on that literal — but the CTA covers five failures now, so `Status:` carries the real one.
 */
export function buildLineMessage({ giftNumber, prefill, branchName, variant }: Args): string {
  const lines = ['USED Gift Request']

  if (variant) lines.push(`Status: ${variant}`)
  if (giftNumber) lines.push(`Gift Number: ${giftNumber}`)

  if (prefill?.date) {
    const parsed = parseISO(prefill.date)
    lines.push(
      `Date: ${Number.isNaN(parsed.valueOf()) ? prefill.date : format(parsed, 'EEEE, MMMM d, yyyy')}`
    )
  }

  if (prefill?.time) lines.push(`Time: ${prefill.time}`)
  if (prefill?.branch) lines.push(`Location: ${branchName ?? prefill.branch}`)
  if (prefill?.guest) lines.push(`Guest: ${prefill.guest}`)

  return lines.join('\n')
}

/**
 * Pre-fills on desktop too, unlike the legacy page. Null when neither env var is set, so the caller
 * can hide the CTA rather than render a dead link.
 */
export function buildLineHref(message: string): string | null {
  const scheme = env.LINE_URL_SCHEME?.trim()
  const plain = env.LINE_URL?.trim()

  if (scheme) return `${scheme}?${encodeURIComponent(message)}`
  if (plain) return plain

  return null
}
